import { z } from "zod";

export const backofficeAcqRateResponseSchema = z.object({
  raw: z.number(),
  interpreted: z.number(),
  isECS: z.boolean(),
});
